export const SERVICE_CATEGORIES = [
  "Handyman", "Plumbing", "Electrical", "Drywall", "Interior Painting", "Exterior Painting",
  "Carpentry", "Landscaping", "Cleaning", "Debris Removal", "Appliance Installation",
  "TV Mounting", "Property Preservation", "Turnovers", "Inspections", "General Repairs",
];

export const URGENCIES = ["Routine", "Priority", "Urgent", "Emergency"];

export const WO_STATUSES = [
  "New", "Under Review", "Awaiting Contractor", "Contractor Assigned", "Scheduled",
  "Estimate Needed", "Estimate Submitted", "Awaiting Client Approval", "Approved",
  "In Progress", "Waiting on Parts", "Completed", "Invoice Pending", "Paid", "Closed", "Cancelled",
];

export const PROPERTY_TYPES = [
  "Single Family", "Duplex", "Condo", "Apartment Community", "Townhouse",
  "Commercial", "Short-Term Rental", "HOA", "Multi-Family",
];

export const APP_STATUSES = ["New", "Reviewing", "Missing Documents", "Approved", "Active", "Inactive", "Rejected"];

export const DOC_TYPES = ["W-9", "Insurance", "Workers Compensation", "Business License", "Trade License", "Certifications", "Portfolio Photos"];

export const US_STATES = ["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];

// Map a status to a pill style key
export function statusPill(status) {
  const map = {
    "New": "new_request", "Under Review": "new_request", "Awaiting Contractor": "assigned",
    "Contractor Assigned": "assigned", "Scheduled": "assigned",
    "Estimate Needed": "pending_estimate", "Estimate Submitted": "pending_estimate",
    "Awaiting Client Approval": "pending_estimate", "Approved": "assigned",
    "In Progress": "in_progress", "Waiting on Parts": "in_progress",
    "Completed": "completed", "Invoice Pending": "invoiced", "Paid": "paid",
    "Closed": "completed", "Cancelled": "declined_issue",
    "Sent": "assigned", "Viewed": "pending_estimate", "Partially Paid": "pending_estimate",
    "Past Due": "declined_issue", "Draft": "new_request",
    "Active": "paid", "Reviewing": "pending_estimate", "Approved ": "paid",
    "Missing Documents": "declined_issue", "Rejected": "declined_issue", "Inactive": "declined_issue",
    "sent": "assigned", "approved": "paid", "revision_requested": "pending_estimate",
    "declined": "declined_issue", "submitted": "pending_estimate",
    "Applicant": "new_request", "Suspended": "declined_issue", "Do Not Assign": "declined_issue",
    "Compliant": "paid", "Needs Documents": "pending_estimate", "Expired Documents": "declined_issue",
    "Under Review": "new_request",
    "Available": "paid", "Busy": "in_progress", "Off Today": "pending_estimate",
    "Unavailable": "declined_issue", "Vacation": "assigned",
  };
  return PILL_STYLES[map[status] || "new_request"];
}

export const PILL_STYLES = {
  new_request: "bg-purple-100 text-purple-800 border-purple-200",
  pending_estimate: "bg-amber-100 text-amber-800 border-amber-200",
  assigned: "bg-blue-100 text-blue-800 border-blue-200",
  in_progress: "bg-indigo-100 text-indigo-800 border-indigo-200",
  completed: "bg-emerald-100 text-emerald-800 border-emerald-200",
  invoiced: "bg-teal-100 text-teal-800 border-teal-200",
  paid: "bg-green-100 text-green-800 border-green-200",
  declined_issue: "bg-rose-100 text-rose-800 border-rose-200",
};

export const URGENCY_STYLES = {
  Routine: "bg-slate-100 text-slate-700 border-slate-200",
  Priority: "bg-blue-100 text-blue-700 border-blue-200",
  Urgent: "bg-orange-100 text-orange-700 border-orange-200",
  Emergency: "bg-rose-100 text-rose-700 border-rose-200",
};

// ---- Contractor management ----
export const CONTRACTOR_STATUSES = ["Applicant", "Reviewing", "Approved", "Active", "Inactive", "Suspended", "Do Not Assign"];
export const ASSIGNABLE_STATUSES = ["Approved", "Active"];
export const AVAILABILITY_STATUSES = ["Available", "Busy", "Off Today", "Unavailable", "Vacation"];
export const COMPLIANCE_STATUSES = ["Compliant", "Needs Documents", "Expired Documents", "Under Review"];
export const TRADES = [
  "Handyman", "Carpentry", "Drywall", "Interior Painting", "Exterior Painting", "Landscaping",
  "Lawn Care", "Janitorial / Cleaning", "Debris Removal", "Property Preservation", "Plumbing",
  "Electrical", "HVAC", "Appliance Installation", "TV Mounting", "Flooring", "Roofing",
  "Pressure Washing", "Turnover / Make Ready", "General Maintenance", "Other",
];
export const COVERAGE_STATES = ["FL", "VA"];
export const COVERAGE_CITIES = {
  FL: ["St. Cloud", "Orlando", "Kissimmee", "Lake Nona", "Osceola County", "Orange County", "Seminole County"],
  VA: ["Chesapeake", "Virginia Beach", "Norfolk", "Portsmouth", "Suffolk", "Hampton", "Newport News"],
};
export const CONTRACTOR_DOC_TYPES = [
  "W-9", "Certificate of Insurance / COI", "General Liability Insurance", "Workers Compensation",
  "Driver's License / ID", "Trade License", "Certifications", "Resume", "Background Check",
  "Independent Contractor Agreement", "Other",
];
